import { gql } from "@apollo/client";

const PRICING_BUNDLE_FIELDS = gql`
  fragment PricingBundleFields on PricingBundle {
    id
    name
    type
    isWeText
    isSingleUse
    description
    prices {
      id
      priceInMillicents
      sku {
        id
        name
        description
      }
    }
  }
`;

const TENANT_ASSIGNMENT_FIELDS = gql`
  ${PRICING_BUNDLE_FIELDS}
  fragment TenantAssignmentFields on TenantPricingBundleAssignment {
    id
    effectiveDate
    expirationDate
    reasonCode
    notes
    createdBy {
      email
      fullName
    }
    pricingBundle {
      ...PricingBundleFields
    }
  }
`;

const SUBACCOUNT_ASSIGNMENT_FIELDS = gql`
  ${PRICING_BUNDLE_FIELDS}
  fragment SubaccountAssignmentFields on SubaccountPricingBundleAssignment {
    id
    subaccountId
    subaccountName
    effectiveDate
    expirationDate
    reasonCode
    notes
    createdBy {
      email
      fullName
    }
    pricingBundle {
      ...PricingBundleFields
    }
  }
`;

export const LIST_ALL_ACTIVE_PRICING_ASSIGNMENTS = gql`
  query ListAllActivePricingAssignments(
    $input: ListAllActivePricingAssignmentsInput!
  ) {
    listAllActivePricingAssignments(input: $input) {
      totalCount
      tenants {
        id
        tenantId
        tenantName
        tenantSlug
        pricingBundleName
        subaccountAssignments {
          id
          subaccountId
          subaccountName
          subaccountSlug
          pricingBundleName
          isWeText
        }
      }
    }
  }
`;

export const GET_ACTIVE_PRICING_BUNDLES = gql`
  ${PRICING_BUNDLE_FIELDS}
  query GetActivePricingBundles {
    getActivePricingBundles {
      ...PricingBundleFields
    }
  }
`;

export const GET_ACTIVE_SKUS = gql`
  query GetActiveSkus {
    getActiveSkus {
      id
      name
      description
      rackPriceInMillicents
    }
  }
`;

export const CHANGE_TENANT_PRICING_ASSIGNMENT = gql`
  mutation ChangeTenantPricingAssignment(
    $input: ChangeTenantPricingAssignmentInput!
  ) {
    changeTenantPricingAssignment(input: $input)
  }
`;

export const CREATE_SUBACCOUNT_PRICING_ASSIGNMENTS = gql`
  mutation CreateSubaccountPricingAssignments(
    $input: CreateSubaccountPricingAssignmentsInput!
  ) {
    createSubaccountPricingAssignments(input: $input)
  }
`;

export const GET_TENANT_PRICING = gql`
  ${TENANT_ASSIGNMENT_FIELDS}
  ${SUBACCOUNT_ASSIGNMENT_FIELDS}
  query GetTenantPricing {
    getTenantPricing {
      currentAssignment {
        ...TenantAssignmentFields
      }
      futureAssignments {
        ...TenantAssignmentFields
      }
      pastAssignments {
        ...TenantAssignmentFields
      }
      currentSubaccountAssignments {
        ...SubaccountAssignmentFields
      }
      futureSubaccountAssignments {
        ...SubaccountAssignmentFields
      }
      pastSubaccountAssignments {
        ...SubaccountAssignmentFields
      }
    }
  }
`;
